"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
require("core-js/modules/es6.function.name");
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-dialog", {
    staticClass: "add_dialog",
    attrs: {
      width: "600px",
      title: _vm.dialogTitle,
      visible: _vm.dialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c("el-form", {
    ref: "form",
    attrs: {
      rules: _vm.rules,
      model: _vm.formData,
      "label-width": "140px"
    }
  }, [_vm.sMerchantId == 0 ? [_c("el-form-item", {
    attrs: {
      label: "商户名称",
      prop: "merchant_id"
    }
  }, [_c("el-select", {
    attrs: {
      placeholder: "请选择"
    },
    model: {
      value: _vm.formData.merchant_id,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "merchant_id", $$v);
      },
      expression: "formData.merchant_id"
    }
  }, _vm._l(_vm.merchantList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.username,
        value: item.id
      }
    });
  }), 1)], 1)] : _vm._e(), _c("el-form-item", {
    attrs: {
      label: "礼包名称",
      prop: "gift_name"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入礼包名称"
    },
    model: {
      value: _vm.formData.gift_name,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "gift_name", $$v);
      },
      expression: "formData.gift_name"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "适用电池",
      prop: "battery_type_id"
    }
  }, [_c("el-select", {
    attrs: {
      placeholder: "请选择"
    },
    model: {
      value: _vm.formData.battery_type_id,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "battery_type_id", $$v);
      },
      expression: "formData.battery_type_id"
    }
  }, _vm._l(_vm.batteryTypeList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.battery_type,
        value: item.id
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "价格(元)",
      prop: "price"
    }
  }, [_c("el-input-number", {
    attrs: {
      "controls-position": "right"
    },
    model: {
      value: _vm.formData.price,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "price", $$v);
      },
      expression: "formData.price"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "换电有效期(天)",
      prop: "lease_time"
    }
  }, [_c("el-input-number", {
    attrs: {
      "controls-position": "right"
    },
    model: {
      value: _vm.formData.lease_time,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "lease_time", $$v);
      },
      expression: "formData.lease_time"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "换电次数(次)",
      prop: "free_times"
    }
  }, [_c("el-input-number", {
    attrs: {
      "controls-position": "right"
    },
    model: {
      value: _vm.formData.free_times,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "free_times", $$v);
      },
      expression: "formData.free_times"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "礼包失效日期",
      prop: "end_time"
    }
  }, [_c("el-date-picker", {
    attrs: {
      type: "date",
      placeholder: "选择日期",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: _vm.formData.end_time,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "end_time", $$v);
      },
      expression: "formData.end_time"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "赠送优惠券",
      prop: "coupon_id"
    }
  }, [_c("el-select", {
    attrs: {
      placeholder: "请选择",
      filterable: "",
      remote: "",
      "remote-method": _vm.remoteMethod,
      loading: _vm.loading
    },
    on: {
      change: function change($event) {
        return _vm.chkCouponId();
      },
      "visible-change": function visibleChange($event) {
        return _vm.remoteMethod();
      }
    },
    model: {
      value: _vm.formData.coupon_id,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "coupon_id", $$v);
      },
      expression: "formData.coupon_id"
    }
  }, _vm._l(_vm.couponList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.id
      }
    });
  }), 1)], 1), _vm.formData.coupon_id > 0 ? _c("el-form-item", {
    attrs: {
      label: "优惠券数量(张)",
      prop: "coupon_num"
    }
  }, [_c("el-input-number", {
    attrs: {
      "controls-position": "right"
    },
    model: {
      value: _vm.formData.coupon_num,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "coupon_num", $$v);
      },
      expression: "formData.coupon_num"
    }
  }), _c("span", [_vm._v(" (0 为不赠送)")])], 1) : _vm._e(), _c("el-form-item", {
    attrs: {
      label: "状态",
      prop: "status"
    }
  }, [_c("el-select", {
    attrs: {
      placeholder: "请选择"
    },
    model: {
      value: _vm.formData.status,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "status", $$v);
      },
      expression: "formData.status"
    }
  }, [_c("el-option", {
    attrs: {
      label: "开启",
      value: 1
    }
  }), _c("el-option", {
    attrs: {
      label: "关闭",
      value: 0
    }
  })], 1)], 1)], 2), _c("div", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      size: "small"
    },
    on: {
      click: function click($event) {
        _vm.dialogVisible = false;
      }
    }
  }, [_vm._v("取 消")]), _c("el-button", {
    attrs: {
      size: "small",
      type: "primary"
    },
    on: {
      click: _vm.submit
    }
  }, [_vm._v("保 存")])], 1)], 1)], 1);
};
exports.render = render;
var staticRenderFns = [];
exports.staticRenderFns = staticRenderFns;
render._withStripped = true;